// open widget tawk
window.openTawkWidget = ($this) => {
  var dataset = $this.dataset

  window.Tawk_API.start();
  window.Tawk_API.toggle();

  var setAttributes = {};

  if (dataset.email != undefined) {
    setAttributes['email'] = dataset.email
  }

  if (dataset.name != undefined) {
    setAttributes['name'] = dataset.name
  }

  if (dataset.phone != undefined) {
    setAttributes['phone'] = dataset.phone
  }

  window.Tawk_API.setAttributes(setAttributes, function(error){});
}
